
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terraform",
      function () {
        return require("private-next-pages/terraform.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terraform"])
      });
    }
  